import { TokenService } from '@admin/core/services/token.service';
import { environment } from '@admin/environments';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, first, map, Observable, switchMap, throwError } from 'rxjs';
import { UserService } from '@admin/states';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private readonly tokenService: TokenService, private readonly userService: UserService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (
      !request.headers.has('Authorization') &&
      !request.url.includes(`profile`) &&
      environment.resource.basePath &&
      (request.url.includes(`/${environment.resource.basePath}`))
    ) {
      return this.tokenService.accessTokenObservable.pipe(
        first(),
        switchMap(token => {
          if (!token) {
            // No token available, user is not authenticated
            // Optionally, redirect to login or throw an error
            // For now, throw an error to be caught by catchError below
            return throwError(() => new Error('Login required'));
          }
          return this.userService.auth$.pipe(
            first(),
            map(auth =>
              request.clone({
                headers: request.headers
                  .set('Authorization', `Bearer ${token}`)
                  .set('X-Requested-With', 'XMLHttpRequest')
                  .set('email', auth?.email ?? '')
                  .set('auth-id', auth?.authId ?? ''),
              }),
            ),
            switchMap(authenticatedRequest => next.handle(authenticatedRequest)),
          );
        }),
        catchError(error => {
          if (error.status === 401 || error.message === 'Login required') {
            this.tokenService.clearTokens();
            this.userService.clear();
            // Optionally, redirect to login page here
          }
          return throwError(() => error);
        }),
      );
    } else {
      return next.handle(request);
    }
  }
}
